export const GPRs = ['Market Rent', 'Quoting Rent', 'Financial Market Rent'];

export const DEVELOPMENT_PHASES = [
  { value: '', text: '--- No Selection ---', disabled: false },
  { value: 'Pre-development', text: 'Pre-development', disabled: false },
  { value: 'Under Construction', text: 'Under Construction', disabled: false },
  { value: 'Lease-up', text: 'Lease-up', disabled: false },
  { value: 'Stabilized', text: 'Stabilized', disabled: false },
  {
    value: 'Renovation/Value Add',
    text: 'Renovation/Value Add',
    disabled: false,
  },
  { value: 'Disposition', text: 'Disposition', disabled: false },
  { value: 'Sold', text: 'Sold', disabled: false },
  { value: 'Redevelopment', text: 'Redevelopment', disabled: false },
  { value: 'Non-operational', text: 'Non-operational', disabled: false },
  { value: 'Distressed', text: 'Distressed', disabled: false },
];
